import { Box, BoxProps } from '@chakra-ui/react';
import TableSection from '../../sections/TableSection/TableSection';
import { CheckIcon } from '@chakra-ui/icons';

interface Props extends BoxProps {}

export const ImplementationTable = ({ ...props }: Props) => {
    const mainCategories = {
        DLA_KOGO: 'Dla kogo',
        CO_ZAWIERA: 'Co zawiera w skrócie',
        INFORMACJE_SZCZEGOLOWE: 'Informacje szczegółowe',
        PRACE_GRAFICZNE: 'Prace graficzne',
        PRACE_INDYWIDUALNE: 'Prace indywidualne',
    };

    const valuesName = {
        BASIC: 'Basic',
        GO: 'Go',
        GO_PLUS: 'Go+',
        INDIVIDUAL: 'Wdrożenie indywidualne',
    };

    const Plus = <CheckIcon fontSize={'lg'} color={'#1AAC7A'} />;

    const Minus = (
        <>
            <span className="table__minus">-</span>
        </>
    );

    const tableSection = [
        {
            category: mainCategories.DLA_KOGO,
            name: '',
            values: {
                BASIC: 'Idealny wybór, jeśli otwierasz swój biznes lub chcesz poszerzyć ofertę stacjonarną o rynek e-commerce.',
                GO: 'Sprawdzi się, jeśli potrzebujesz materiałów graficznych na BASIC lub przenosisz swój sklep z innej platformy.',
                GO_PLUS:
                    'Sprawdzi się, jeśli chcesz dostosować wygląd swojego sklepu lub przenieść go z innej platformy.',
                INDIVIDUAL:
                    'Wybierz, jeśli zależy ci na unikalnym interfejsie sklepu i rozwiązaniu dostosowanym dla twojego biznesu.',
            },
        },
        {
            category: mainCategories.CO_ZAWIERA,
            name: '',
            values: {
                BASIC: (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: '<div style="height: inherit;"><ul style="list-style:none"><li>Dedykowany opiekun wdrożenia</li><li>Dostęp do darmowego szablonu sklepu</li><li>Konfiguracja sklepu wraz ze szkoleniem online</li><li>Import towarów i klientów</li><li>Przygotowanie sprzedaży stacjonarnej POS</li><li>Migracja sklepu z innej platformy</li></ul></div>',
                        }}
                    ></Box>
                ),
                GO: (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: '<div style="height: inherit;"><b>Wszystkie rozwiązania Pakietu BASIC</b><ul style="list-style:none"><li>W ramach jednego dnia projektowego projektant graficzny dobierze schemat kolorystyczny i czcionki w szablonie, a także pomoże Ci przygotować materiały graficzne na BASIC sprzedaży, takie jak bannery albo proste logo. Zakres wykonywanych prac graficznych jest ustalany indywidualnie podczas umówionego dnia projektowego.</li></ul></div>',
                        }}
                    ></Box>
                ),

                GO_PLUS: (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: '<div style="height: inherit;"><b>Wszystkie rozwiązania Pakietu GO</b><ul style="list-style:none"><li>Udział eksperta UI/UX w procesie modyfikacji szablonu sklepu</li><li>Dostosowanie motywu i zestawu komponentów szablonu pod typ Twojego biznesu</li><li>3 widoki desktop szablonu sklepu: strona główna, lista towarów i karta towaru wykonane przez eksperta UI/UX na podstawie gotowych komponentów</li></ul></div>',
                        }}
                    ></Box>
                ),

                INDIVIDUAL: (
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: '<div style="height: inherit;"><b>Wszystkie rozwiązania Pakietów GO+</b><ul style="list-style:none"><li>Stworzenie unikatowego projektu interfejsu sklepu przez ekspertów UX/UI</li><li>Wdrożenie gotowego projektu interfejsu sklepu</li><li>Stworzenie specjalistycznych rozwiązań dla twojego biznesu</li><li>Niestandardowe integracje i aplikacje wykraczające poza rozwiązania systemu IdoSell</li><li>Możliwość migracji sklepu i przeniesienia indywidualnego rozwiązania zastosowanego na dotychczasowej platformie</li></ul></div>',
                        }}
                    ></Box>
                ),
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Dostęp do darmowego szablonu sklepu',
            values: {
                BASIC: Plus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Konfiguracja sklepu i szkolenie',
            values: {
                BASIC: Plus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Konfiguracja sprzedaży stacjonarnej POS',
            values: {
                BASIC: Plus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Import towarów i klientów z dowolnej platformy',
            values: {
                BASIC: Plus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Dedykowany opiekun wdrożenia',
            values: {
                BASIC: Plus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.INFORMACJE_SZCZEGOLOWE,
            name: 'Konsultacja z ekspertem UI/UX w celu omówienia układu szablonu po zasileniu i skonfigurowaniu sklepu',
            values: {
                BASIC: Minus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_GRAFICZNE,
            name: 'Dostosowanie motywu kolorystycznego szablonu sklepu, maili transakcyjnych oraz fontów',
            values: {
                BASIC: Minus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_GRAFICZNE,
            name: 'Przygotowanie materiałów graficznych na BASIC w ramach dnia projektowego (np. proste logo lub banery)',
            values: {
                BASIC: Minus,
                GO: Plus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_GRAFICZNE,
            name: 'Udział eksperta UI/UX w procesie tworzenia sklepu',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_GRAFICZNE,
            name: 'Dostosowanie układu komponentów szablonu pod potrzeby branży lub typ sklepu (np. sklep multibrandowy lub jednobrandowy)',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_GRAFICZNE,
            name: 'Widoki desktop 3 stron wykonane przez eksperta UI/UX w oparciu o gotowe komponenty dostosowane do potrzeb Twojego biznesu',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_INDYWIDUALNE,
            isGray: true,
            name: 'Niestandardowe integracje i aplikacje wykraczające poza rozwiązania systemu Idosell',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Minus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_INDYWIDUALNE,
            isGray: true,
            name: 'Indywidualny projekt interfejsu sklepu współtworzony z ekspertem UI/UX',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Minus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: mainCategories.PRACE_INDYWIDUALNE,
            isGray: true,
            name: 'Indywidualne rozwiązania pod potrzeby Twojego biznesu',
            values: {
                BASIC: Minus,
                GO: Minus,
                GO_PLUS: Minus,
                INDIVIDUAL: Plus,
            },
        },
    ];
    return (
        <Box {...props}>
            <TableSection
                title="Informacje dodatkowe o pakietach wdrożeniowych"
                valuesName={valuesName}
                mainCategories={mainCategories}
                tableSection={tableSection}
                tableColumns={4}
                isOpenAll={true}
            />
        </Box>
    );
};
